import React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';

export const ProductAvailabilityNotificationSuccess = () => {
    return (
        <div className="ProductAvailabilityNotificationSuccess">
            <div className="ProductAvailabilityNotificationSuccess__Icon" />
            <div className="ProductAvailabilityNotificationSuccess__Info">
                <span className="ProductAvailabilityNotificationSuccess__Heading">{getTranslation(keys['product.availabilityNotification.savedHeading'])}</span>
                <span className="ProductAvailabilityNotificationSuccess__Subheading">
                    {getTranslation(keys['product.availabilityNotification.savedSubheading'])}
                </span>
            </div>
        </div>
    );
};
